import StatusBadge from './StatusBadge';

const CATEGORY_LABELS = {
  action_figures: 'Action Figures',
  arts_crafts: 'Arts & Crafts',
  board_games: 'Board Games',
  card_games: 'Card Games',
  construction: 'Construction',
  dolls: 'Dolls',
  educational: 'Educational',
  electronic: 'Electronic',
  outdoor: 'Outdoor',
  plush: 'Plush',
  pretend_play: 'Pretend Play',
  puzzles: 'Puzzles',
  ride_on: 'Ride-On',
  sensory: 'Sensory',
  stem: 'STEM',
  vehicles: 'Vehicles',
  other: 'Other',
};

export default function IdeaCard({ idea, onClick }) {
  const thumbnail = idea.idea_assets?.find(a =>
    a.file_type?.startsWith('image/')
  );
  const profile = idea.idea_profiles?.[0] || idea.idea_profiles;

  return (
    <button
      onClick={() => onClick(idea)}
      className="w-full text-left bg-white rounded-xl border border-vault-border hover:border-vault-gold/50 hover:shadow-md transition-all p-4"
    >
      {/* Thumbnail */}
      {thumbnail ? (
        <div className="w-full h-36 rounded-lg bg-gray-100 mb-3 overflow-hidden">
          <img
            src={thumbnail.file_url}
            alt={idea.title}
            className="w-full h-full object-cover"
          />
        </div>
      ) : (
        <div className="w-full h-36 rounded-lg bg-gradient-to-br from-vault-navy/5 to-vault-gold/10 mb-3 flex items-center justify-center">
          <span className="text-3xl opacity-30">&#128161;</span>
        </div>
      )}

      {/* Title + Status */}
      <div className="flex items-start justify-between gap-2 mb-2">
        <h3 className="font-semibold text-vault-navy text-sm leading-tight line-clamp-2">{idea.title}</h3>
        <StatusBadge status={idea.status} />
      </div>

      {/* Description preview */}
      {idea.description && (
        <p className="text-xs text-gray-500 line-clamp-2 mb-3">{idea.description}</p>
      )}

      {/* Category + Profile pills */}
      <div className="flex flex-wrap gap-1.5">
        {(idea.category || profile?.product_category) && (
          <span className="text-xs px-2 py-0.5 bg-vault-surface rounded-full text-gray-600">
            {CATEGORY_LABELS[profile?.product_category || idea.category] || idea.category}
          </span>
        )}
        {profile?.target_age_range && (
          <span className="text-xs px-2 py-0.5 bg-vault-surface rounded-full text-gray-600">
            Ages {profile.target_age_range}
          </span>
        )}
        {profile?.estimated_cost_tier && (
          <span className="text-xs px-2 py-0.5 bg-vault-surface rounded-full text-gray-600">
            {profile.estimated_cost_tier}
          </span>
        )}
      </div>

      {/* Assets count */}
      {idea.idea_assets?.length > 0 && (
        <div className="mt-3 text-xs text-gray-400">
          {idea.idea_assets.length} file{idea.idea_assets.length !== 1 ? 's' : ''}
        </div>
      )}
    </button>
  );
}
